import { useRef, useCallback } from "react";

function isAgGridCheckboxClick(event) {
  const target = event?.event?.target;
  if (!(target instanceof Element)) {
    return false;
  }
  return Boolean(
    target.closest(
      ".ag-checkbox-input-wrapper, .ag-selection-checkbox, input.ag-checkbox-input",
    ),
  );
}

/** Click anywhere on the row to toggle selection; checkbox clicks are unchanged. */
export const pgGridRowClickToggleProps = {
  suppressRowClickSelection: true,
  onRowClicked: (event) => {
    if (isAgGridCheckboxClick(event)) {
      return;
    }
    event.node.setSelected(!event.node.isSelected());
  },
};

/**
 * AG Grid multi-select capped at `maxSelection` (keeps the newly selected row).
 * @param {number|null|undefined} maxSelection — when null/undefined, no cap
 */
export function useLimitedGridSelection(onSelectionChanged, maxSelection, getRowId) {
  const prevIdsRef = useRef([]);

  const onGridSelectionChanged = useCallback(
    (event) => {
      const api = event.api;
      let nodes = api.getSelectedNodes();
      const idOf = (row) => (getRowId ? getRowId(row) : row.id);

      if (
        maxSelection != null &&
        maxSelection > 0 &&
        nodes.length > maxSelection
      ) {
        const prev = new Set(prevIdsRef.current);
        const added = nodes.find((n) => !prev.has(idOf(n.data)));
        api.deselectAll();
        const keep = added || nodes[nodes.length - 1];
        if (keep) {
          keep.setSelected(true);
        }
        nodes = api.getSelectedNodes();
      }

      const rows = api.getSelectedRows();
      prevIdsRef.current = rows.map((r) => idOf(r));
      onSelectionChanged(rows);
    },
    [onSelectionChanged, maxSelection, getRowId],
  );

  return onGridSelectionChanged;
}
